import {Collapse, Divider} from 'antd';
import moment from 'moment';
import {calendar} from '../../../assets/imageDir';

const RepeatClassesUI = ({
  repeatIdClasses,
  repeatId,
  participantNamesById = {},
  hasSelectedRegistrants = false,
}) => {
  const collapseItems = repeatIdClasses?.map(classItem => ({
    key: classItem?.uuid,
    label: (
      <div>
        <div className="date-time-div date-time-text-div mb-2">
          <div className="date-div">
            <span className="_icon">
              <img src={calendar} alt="" />
            </span>
            {moment(classItem?.start_branch_time).format('dddd, MMMM Do YYYY')}
          </div>
          <div className="time-div">
            <span className="_icon">
              <i className="far fa-clock"></i>
            </span>
            {moment(classItem?.start_branch_time).format('hh:mm A')}
          </div>
          <Divider type="vertical" style={{marginRight: '-10px', marginLeft: '-10px'}} />
          <div>{classItem?.serviceName}</div>
        </div>
        <div className="text-muted pl-3">
          Registrants:{' '}
          {hasSelectedRegistrants && classItem?.participantMemberIds?.length > 0
            ? classItem.participantMemberIds
                .map(participantId => participantNamesById[participantId] || participantId)
                .join(', ')
            : 'None selected yet'}
        </div>
      </div>
    ),
    children: <pre className="desc-normal">{classItem.description}</pre>,
  }));

  const headCollapse = [
    {
      key: '1',
      label: (
        <p className="text-dark text-left pl-3 text-dark fw-normal">
          View Dates and Additional Details
        </p>
      ),
      children: <Collapse items={collapseItems} bordered={false} />,
    },
  ];

  if (repeatId) {
    return (
      <>
        {/* <p className="text-dark bg-light text-left pl-3 py-2 my-3 text-dark fw-normal">
          All Event Days
        </p> */}
        <Collapse
          items={headCollapse}
          bordered={false}
          style={{
            backgroundColor: '#f0f2f6',
          }}
        />
      </>
    );
  } else {
    return null;
  }
};

export default RepeatClassesUI;
